<template lang="pug">
  .property
    label(v-if="showLabel") {{ property.name }}
    .values
      template(v-if="property.type === 'color'")
        // TODO: check for image swatch
        template(v-for="el in property.values")
          template(v-if="el.value_alt")
            span.color-tile(:style="{ background: el.value_alt }")
          span.text-tile(v-else) {{ el.value }}
      template(v-else)
        .text-tile(v-for="el in property.values")
          | {{ el.value }}
</template>

<script>
export default {
  name: 'TeaserProperty',
  props: {
    property: {
      type: Object,
      required: true
    },
    showLabel: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="sass" scoped>
.property
  font-size: .85rem
  .text-tile
    @apply rounded
    display: inline
    padding: 3px 6px
    background-color: theme('colors.gray.300')
    margin: 0 2px
  .color-tile
    @apply border-1 border-gray-400
    margin: 0 2px
    display: block
    width: 22px
    height: 22px
</style>
